// Material UI
import { Checkbox, FormControlLabel } from '@mui/material'

// Hook Form
import { Controller } from 'react-hook-form'

import { setDirtyForm } from '../../../services/appPreferences/dirtyFormStorage'

const CheckBoxWrapper = ({ control, formField, rules, groupIndex, readOnly }) => {
  return (
    <FormControlLabel
      control={
        <Controller
          control={control}
          defaultValue={formField.defaultValue}
          name={`${formField.name}${groupIndex ? `-${groupIndex}` : ''}`}
          render={({ field }) => (
            <Checkbox
              checked={field.value}
              disabled={readOnly}
              onChange={(evt, value) => {
                field.onChange(value)
                if (!readOnly) setDirtyForm(true)
              }}
            />
          )}
          rules={rules}
        />
      }
      label={formField.label}
    />
  )
}

export default CheckBoxWrapper
